module.exports = __webpack_public_path__ + "img/benzol-mesomer.fdae503d.png";